import script from "./archivePage.vue?vue&type=script&setup=true&lang=js"
export * from "./archivePage.vue?vue&type=script&setup=true&lang=js"

import "./archivePage.vue?vue&type=style&index=0&id=54c11f1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c11f1d"]])

export default __exports__